import moment from 'moment';
export class TaskClock {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.taskImage = form.taskImage;
      // this.time = [form.beginTime, form.endTime];
      this.duration = form.duration;
      this.registrationTime = [form.registrationBeginTime, form.registrationEndTime];
      this.taskDateTime = (form.registrationBeginTime && form.registrationEndTime) ? [form.registrationBeginTime, form.registrationEndTime] : [form.beginTime, form.endTime];
      this.registrationBeginTime = form.registrationBeginTime; // 报名开始日期
      this.registrationEndTime = form.registrationEndTime; // 报名截止日期
      this.taskIntroduction = form.taskIntroduction; // 任务介绍
      this.announcement = form.announcement; // 注意事项
      this.movingTarget = form.movingTarget.map(item => item.id);
      this.summaryCopy = form.summaryCopy;// 小结文案
      this.lotteryRules = form.lotteryRules;// 抽奖规则
      this.taskDateNum = form.taskDateNum;// 打卡日期
      this.title = form.title;
      this.taskList = {};
      this.crmLotteryId = form.crmLotteryId || ""; // crm抽奖id
      // this.taskDateCalculation = form.taskDateCalculation; // 打卡日期计算方式 0- 报名第二天打卡开始，1-自定义
      // this.prizeInformationAddDTOList = form.prizeInformationAddDTOList ? form.prizeInformationAddDTOList : [{
      //   prizeLevel: 1,
      //   prizeName: "",
      //   prizeNum: null,
      // }];
    } else {
      this.clear();
    }
  }

  get taskDateTime() {
    if (this.beginTime && this.endTime) {
      return [this.beginTime, this.endTime];
    } else {
      return [];
    }
  }

  set taskDateTime(time) {
    if (time && Array.isArray(time) && time.length === 2) {
      this.beginTime = time[0];
      this.endTime = time[1];
      const diff = this.beginTime === this.endTime ? 1 : moment(this.endTime).diff(this.beginTime, 'days') + 1;
      this.duration = diff;
    } else {
      this.beginTime = "";
      this.endTime = "";
      this.duration = 0;
    }
  }
  get registrationTime() {
    if (this.registrationBeginTime && this.registrationEndTime) {
      return [this.registrationBeginTime, this.registrationEndTime];
    } else {
      return [];
    }
  }

  set registrationTime(time) {
    if (time && Array.isArray(time) && time.length === 2) {
      this.registrationBeginTime = time[0];
      this.registrationEndTime = time[1];
    } else {
      this.registrationBeginTime = "";
      this.registrationEndTime = "";
    }
  }

  formatForm() {
    if (this.prizeInformationAddDTOList) {
      // 格式化掉没有名称的奖品
      this.prizeInformationAddDTOList = this.prizeInformationAddDTOList.filter((item, index) => {
        return item.prizeName && item.prizeNum && item.prizeNum !== '0';
      });
      // 再格式化变量中的类型
      if (this.prizeInformationAddDTOList.length) {
        this.prizeInformationAddDTOList = this.prizeInformationAddDTOList?.map((item) => {
          return {
            ...item,
            prizeNum: Number(item.prizeNum),
          };
        });
      }
    }
  }

  clear() {
    this.id = "";
    this.time = [];
    this.duration = 0;
    this.registrationTime = [];
    this.taskDateTime = []; // 打卡开始结束时间
    this.taskImage = {
      listPictures: "", // 列表页图片
      taskDetailsPageHeader: "", // 任务详情页头图
      taskShareCardImage: "", // 小程序分享卡片图片
      taskShareImage: "", // 任务长图分享图片
      myMatchListPictures: "", // 我的活动列表页图片
    };
    this.registrationBeginTime = ""; // 报名开始日期
    this.registrationEndTime = ""; // 报名截止日期
    this.taskIntroduction = ""; // 任务介绍
    this.announcement = ""; // 注意事项
    this.taskDateNum = null;
    this.movingTarget = [];
    this.summaryCopy = "";
    this.lotteryRules = "";// 抽奖规则
    this.title = "";
    this.taskList = {};
    this.crmLotteryId = "";
    // this.taskDateCalculation = 0;
    // this.prizeInformationAddDTOList = [{
    //   prizeLevel: 1,
    //   prizeName: "",
    //   prizeNum: null,
    // }]; // 奖品配置
  }
}
